<h1 mat-dialog-title>Device Report Settings</h1>

<mat-dialog-content>
  <div class="data-section">Displayed columns</div>
  <div class="data-section-wrapper">
    @for (column of data.columns; track column) {
      <mat-checkbox class="form-input" [(ngModel)]="column.displayed">{{ column.name }}</mat-checkbox>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button color="accent" (click)="buttonClickedOk()" [disabled]="!isDialogValid()">OK</button>
</mat-dialog-actions>
